/**
 * UranIA PA — OIDC silent renew callback (US-009 / US-010).
 *
 * Route `/auth/silent-renew` — iframe hidden gestito da
 * `automaticSilentRenew` di oidc-client-ts. Non rende nulla di visibile:
 * chiama `signinSilentCallback()` e termina. La pagina è invisibile
 * all'utente; basta che esista perché Keycloak vi reindirizzi.
 */

import { useEffect } from 'react';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { completeSilentRenew } from '../lib/auth/login-actions.ts';
import { Route as RootRoute } from './__root.tsx';

function SilentRenewPage(): JSX.Element {
  useEffect(() => {
    void completeSilentRenew().catch(() => {
      // L'errore qui non è visibile all'utente (iframe nascosto). Il
      // UserManager emette un evento `silentRenewError` che la SPA potrà
      // intercettare per forzare un `signinRedirect`. Per ora swallowing —
      // niente console.error in produzione per evitare leak in audit logs
      // del browser (analisi §20.5).
    });
  }, []);
  return <div data-testid="silent-renew" hidden />;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/silent-renew',
  component: SilentRenewPage,
});
